import { GetterTree } from 'vuex';
import { State } from '@/stores/enquiries/state';

export class Getters implements GetterTree<State, any> {
    [key: string]: (state: State, getters: any, rootState: any, rootGetters: any) => any;

    public allEnquiries = (state: State) => state.allEnquiries;
    public allEnquiriesPage = (state: State) => state.allEnquiriesPageNumber;
    public allEnquiriesPageSize = (state: State) => state.allEnquiriesPageSize;
    public allEnquiriesTotalPages = (state: State) => state.allEnquiriesTotalPages;
    public allEnquiriesTotal = (state: State) => state.allEnquiriesTotal;
    public allEnquiriesKeyword = (state: State) => state.allEnquiriesKeyword;
    public allEnquiriesFilterStatus = (state: State) => state.allEnquiriesFilterStatus;
    public allEnquiriesFrom = (state: State) => state.allEnquiriesFrom;
    public allEnquiriesTo = (state: State) => state.allEnquiriesTo;

    public myEnquiries = (state: State) => state.myEnquiries;
    public myEnquiriesPage = (state: State) => state.myEnquiriesPageNumber;
    public myEnquiriesPageSize = (state: State) => state.myEnquiriesPageSize;
    public myEnquiriesTotalPages = (state: State) => state.myEnquiriesTotalPages;
    public myEnquiriesTotal = (state: State) => state.myEnquiriesTotal;
    public myEnquiriesKeyword = (state: State) => state.myEnquiriesKeyword;
    public myEnquiriesFilterStatus = (state: State) => state.myEnquiriesFilterStatus;
    public myEnquiriesFrom = (state: State) => state.myEnquiriesFrom;
    public myEnquiriesTo = (state: State) => state.myEnquiriesTo;
}
